/**
 * 回傳 Home Page 相關資料
 */

export function useHomeData() {
  const { blobDomain } = useWebsite();

  /**
   * 提供完整的圖片網址
   * @param url - 圖片相對路徑
   * @returns 完整的圖片網址
   */

  const provideImgUrl = (url: string): string => {
    return `${blobDomain.value}/wise-paas-marketplace/pages/home/sections/${url}`;
  };

  /**
   * 提供背景圖片樣式
   * @param url - 圖片相對路徑
   * @returns CSS 背景圖片樣式字串
   */

  const provideBackgroundUrl = (url: string): string => {
    return `background-image: url(${blobDomain.value}/wise-paas-marketplace/pages/home/sections/${url})`;
  };

  return {
    provideImgUrl,
    provideBackgroundUrl,
  };
}
